import React from 'react';
import { motion } from 'framer-motion';

const SolutionSection: React.FC = () => {
  return (
    <section id="como-funciona" className="pt-12 md:pt-16 pb-8 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Texto à esquerda */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-4xl font-bold text-primary mb-6 leading-tight">
              CONHEÇA A <span className="text-primary" style={{ color: '#004080' }}>GERAÇÃO DISTRIBUÍDA</span>:
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Enviamos energia das <span style={{ color: '#222222', fontWeight: 'bold' }}>nossas usinas solares</span> para o seu comércio através da sua distribuidora e rede elétrica atual. 
              Você recebe energia limpa sem obras ou investimento inicial e <strong style={{ color: '#222222' }}>não precisa mais se preocupar</strong> com os custos energéticos 
              que <span style={{ color: '#222222', fontWeight: 'bold' }}>sugam o seu lucro.</span>
            </p>
          </motion.div>

          {/* Visual à direita */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="relative">
              {/* Imagem real de geração distribuída */}
              <img 
                src="/GD.webp" 
                alt="Usina solar geração distribuída" 
                className="w-full h-64 md:h-80 object-contain rounded-sm shadow-md border border-gray-200 bg-gray-50" 
                loading="lazy"
              />
              {/* Badge overlay */}
              {/* <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-sm shadow-lg">
                <p className="text-sm font-medium text-primary">Geração Distribuída</p>
                <p className="text-xs text-gray-600">Energia limpa para seu negócio</p>
              </div> */}
            </div>
          </motion.div>
        </div>

        {/* CTA Centralizado */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-16"
        >
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6">
            Essa é a solução que o seu negócio precisa!
          </h3>
          <a
            href="#hero"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-semibold text-lg rounded-lg shadow-lg hover:from-yellow-500 hover:to-yellow-600 transform hover:scale-105 transition-all duration-300"
          >
            QUERO ESTA SOLUÇÃO
            <svg 
              className="ml-2 w-5 h-5" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionSection; 